import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	sidebarNavigation: {
		id: 'page-container-v2.common.sidebar.sidebar-navigation',
		defaultMessage: 'Sidebar navigation',
		description:
			'The (>)/(<) button label for expand and collapse sidebar in the sidebar navigation, hover to see the text.',
	},
	sideBarPanelSplitterLabel: {
		id: 'page-container-v2.common.sidebar.side-bar-panel-splitter-label',
		defaultMessage: 'Resize side navigation panel',
		description: 'Button label for resizing the side navigation panel',
	},
	globalInviteButtonLabel: {
		id: 'page-container-v2.common.sidebar.global-invite-button-label',
		description: 'Text content of the button that triggers the modal dialog.',
		defaultMessage: 'Invite people',
	},
});
